import React from 'react';
import { Box, Checkbox, ChevronDownIcon, ChevronUpIcon, Inscription } from '@common-fe/common-fe';

import { Category } from '../../EligibleServices.types';
import TableItemWrapper from '../TableItemWrapper';

import ServicesTable from './ServicesTable';
import { useCategoryItemActions } from './useCategoryItemActions';

interface Props {
  data: Category;
  isExpanded: boolean;
  isChecked: boolean;
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  isPlanActive?: boolean;
  isEditableTemplate?: boolean;
  isIndeterminate?: boolean;
  isPerCategorySpendLimit?: boolean;
  parentId?: number;
  onExpandCategoryId: (id: string) => void;
  onSelect: (id: string) => void;
}

const CategoryItem: React.FC<Props> = ({
  data,
  isExpanded,
  isChecked,
  isEditMode,
  isTemplateMode,
  isPlanActive,
  isEditableTemplate,
  isIndeterminate,
  isPerCategorySpendLimit,
  parentId,
  onExpandCategoryId,
  onSelect,
}) => {
  const { isDisabled, spendLimitDisplay, handleCheckBoxClick, handleChange } = useCategoryItemActions({
    category: data?.category,
    id: data?.id,
    isEditMode,
    isTemplateMode,
    isPlanActive,
    isEditableTemplate,
    isPerCategorySpendLimit,
    isChecked,
    isIndeterminate,
    onSelect,
  });

  return (
    <TableItemWrapper isChecked={isChecked}>
      <Box
        data-testid="category-item"
        direction="row"
        align="center"
        onClick={() => onExpandCategoryId(data?.id)}
      >
        <Box
          direction="row"
          width={parentId ? '4%' : '8%'}
          justify="start"
          align="center"
          pad={{ left: 'xs' }}
        >
          {!parentId && (
            <Checkbox
              testId="category-item-checkbox"
              name={data?.category}
              disabled={isDisabled}
              onChange={handleChange}
              onClick={handleCheckBoxClick}
              checked={isChecked}
              manualIndeterminate={isIndeterminate}
            />
          )}
          <Box width="24px">
            {isExpanded ? <ChevronUpIcon color="textTitle" /> : <ChevronDownIcon color="textTitle" />}
          </Box>
        </Box>
        <Box width={parentId ? '48%' : isPerCategorySpendLimit ? '35%' : '45%'}>
          <Inscription lineHeight="20px" color="textBody" weight="bold">
            {data?.category}
          </Inscription>
        </Box>
        <Box width={parentId ? '48%' : isPerCategorySpendLimit ? '30%' : '47%'}>
          <Inscription lineHeight="20px" color="textBody">
            {data?.servicesTotal}
          </Inscription>
        </Box>
        {isPerCategorySpendLimit ? (
          <Box width={parentId ? '48%' : '27%'}>
            <Inscription lineHeight="20px" color="textBody">
              {spendLimitDisplay}
            </Inscription>
          </Box>
        ) : null}
      </Box>
      {isExpanded ? (
        <Box margin={{ top: 'spacing8', bottom: 'spacing6' }}>
          <ServicesTable
            services={data?.services}
            total={data?.servicesTotal}
            parentId={parentId}
            isDisabled={isDisabled}
          />
        </Box>
      ) : null}
    </TableItemWrapper>
  );
};

export default CategoryItem;
